import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export const ApiInterceptor: HttpInterceptorFn = (
  request: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  const BASE_URL = environment.apiEndpoint;

  const headers = request.headers
    .set('Cache-Control', 'no-cache')
    .set('Pragma', 'no-cache')
    .set('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT');

  const clonedRequest = request.clone({
    url: BASE_URL + request.url,
    withCredentials: true,
    headers
  });

  // console.log('[ApiInterceptor] Request:', {
  //   url: clonedRequest.url,
  //   method: clonedRequest.method,
  //   withCredentials: clonedRequest.withCredentials,
  //   headers: clonedRequest.headers.keys().reduce((acc, key) => ({ ...acc, [key]: clonedRequest.headers.get(key) }), {})
  // });

  return next(clonedRequest);
};
